import { __require as r } from "../Errors.mjs";
import { __require as e } from "../Request.mjs";
import { __require as t } from "./Result.mjs";
import { __require as s } from "../util/buildInputData.mjs";
import { __require as o } from "../util/apiToSDKKeyMap.mjs";
var i, n;
function u() {
  if (n) return i;
  n = 1;
  const u = r(),
    a = e(),
    m = t(),
    p = s(),
    _ = o().usExtract;
  return i = class {
    constructor(r) {
      this.sender = r;
    }
    send(r) {
      if (void 0 === r) throw new u.UndefinedLookupError();
      let e = new a(r.text, {
        "Content-Type": "text/plain; charset=utf-8"
      });
      return e.parameters = p(r, _), new Promise((t, s) => {
        this.sender.send(e).then(e => {
          e.error && s(e.error), r.result = new m(e.payload), t(r);
        }).catch(s);
      });
    }
  };
}
export { u as __require };